import Timeline from "@/components/UI/Timeline/Timeline";
import TimelineItem from "@/components/UI/Timeline/TimelineItem";
import TimelineItemContent from "@/components/UI/Timeline/TimelineItemContent";
import TimelineItemDot from "@/components/UI/Timeline/TimelineItemDot";
import { getCombinedJobHistory } from "@/utils/job";
import classNames from "classnames";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import ChangesDetectedCard from "./ChangesDetectedCard";
import NoChangesDetectedCard from "./NoChangesDetectedCard";

interface Section17Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const JobHistorySection = ({ className, job, page, section, ...props }: Section17Props) => {
  const combinedJobHistory = getCombinedJobHistory({
    job,
  }).filter((item) => {
    return !item.history?.error_log_id;
  });

  return (
    <Section className={classNames("bg-vpBlue-100", className)} section={section} {...props}>
      <SectionContainer className="lg:max-w-screen-lg" section={section}>
        <SectionHeader section={section} />
        {combinedJobHistory.length > 0 ? (
          <Timeline>
            {combinedJobHistory.map((item, index) => {
              return (
                <TimelineItem key={index}>
                  <TimelineItemDot className={item?.changes ? "bg-vpBlue-500" : "bg-vpBlue-200"} />
                  <TimelineItemContent className="w-full rounded-lg">
                    {item?.changes ? (
                      <ChangesDetectedCard historyItem={item?.changes} page={page} section={section} />
                    ) : item?.history ? (
                      <NoChangesDetectedCard historyItem={item?.history} page={page} section={section} />
                    ) : null}
                  </TimelineItemContent>
                </TimelineItem>
              );
            })}
          </Timeline>
        ) : (
          <div className="flex justify-center">
            <div className="text-xl text-vpGray-700">
              {"No updates found, please try again later." ?? section?.EmptyHistoryBody}
            </div>
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default JobHistorySection;
